import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { useUserQuery } from '../../../features/user/useUserQuery';
import { AssetsService } from '../../../services/AssetsService';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import {
  LockScreenContainer,
  StyledLockScreenHeading,
  StyledLockScreenImage,
  StyledRestrictedAccessText,
} from '../styles';

import { StyledButton } from './styles';

export const QuizNotCompletedGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const { data } = useUserQuery();
  const { t } = useTranslation();
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleCompleteQuizButtonClick = () => {
    dispatchTrackEventWithLocation('hooks', 'click complete quiz', 'complete quiz button');
    window.open('https://pro.similarweb.com', '_blank');
  };

  if (data && !data.isRegistrationQuizCompleted) {
    return (
      <LockScreenContainer variant="quiz">
        <StyledLockScreenImage
          data-automation="QuizNotCompletedImage"
          src={AssetsService.assetUrl('/images/extension-illustration.png')}
          alt="extension"
          variant="restricted"
        />
        <StyledLockScreenHeading data-automation="QuizNotCompletedHeading" variant="quiz">
          {t('common.sales_intelligence')}
        </StyledLockScreenHeading>
        <StyledRestrictedAccessText data-automation="QuizNotCompletedText">
          {t('quiz.not.completed.text')}
        </StyledRestrictedAccessText>
        <StyledButton data-automation="QuizNotCompletedButton" onClick={handleCompleteQuizButtonClick} variant="trial">
          {t('quiz.not.completed.button')}
          <SWReactIcons iconName="arrow-right" size="xs" iconColor={colorsPalettes.carbon[0]} />
        </StyledButton>
      </LockScreenContainer>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
